import { type FC } from "react";

import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { getVariantEffectDisplayValue } from "./VariantEffectCell.js";
import ListCellContent, { type ListCellItem } from "./core/ListCellContent.js";
import { TableCell } from "./core/TableCell.js";

const VariantEffectsListCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value) {
    return null;
  }

  const effects: string[] = props.value;

  const items: ListCellItem[] = effects.map((effect: string) => ({
    value: getVariantEffectDisplayValue(effect),
    tooltip: effect,
  }));

  return (
    <TableCell>
      <ListCellContent items={items} colDef={props.colDef} context={props.context} />
    </TableCell>
  );
};

export { VariantEffectsListCell };
export default VariantEffectsListCell;
